import type { FunctionComponent, PropsWithChildren } from "react"

import { clsx } from "clsx"

import { Text } from "@jobteaser/spark/components/Text"
import { Icon, ICON_SIZES } from "@jobteaser/ui-kit/dist/module/components/Icon/Icon"

import styles from "./KeyInformation.module.css"

type KeyInformationProps = {
  title: string
  icon?: SVGElement
  className?: string
  colorReverse?: boolean
  noSpacing?: boolean
}

export const KeyInformation: FunctionComponent<PropsWithChildren<KeyInformationProps>> = ({
  title,
  icon,
  className,
  colorReverse,
  noSpacing,
  children,
}) => (
  <div
    className={clsx([
      styles.keyInformation,
      {
        [styles["keyInformation--withIcon"]]: icon,
        [styles["keyInformation--noSpacing"]]: noSpacing,
        [styles["keyInformation--colorReverse"]]: colorReverse,
      },
      className,
    ])}
    data-testid="company_key_information"
  >
    {icon && (
      <figure className={styles.keyInformation__icon} data-testid="company_key_information_icon">
        <Icon size={ICON_SIZES.BIG} xlinkHref={`#${icon.id}`} role="graphics-symbol" />
      </figure>
    )}
    <div data-testid="company_key_information_content">
      <Text variant="body2" weight="regular" data-testid="company_key_information_title">
        {title}
      </Text>
      {children}
    </div>
  </div>
)
